import axios from 'axios';
import { urlAssociates } from '../utils';

export const apiAssociates = axios.create({
    baseURL: `${urlAssociates}`
});